import { render, staticRenderFns } from "./area-panel.vue?vue&type=template&id=4d53f366&scoped=true"
import script from "./area-panel.vue?vue&type=script&lang=ts"
export * from "./area-panel.vue?vue&type=script&lang=ts"
import style0 from "./area-panel.vue?vue&type=style&index=0&id=4d53f366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53f366",
  null
  
)

export default component.exports